<div class="layout">
    <app-top-bar [nombreModulo]="nombreModulo"></app-top-bar>

    <div>
        <router-outlet tabindex="1" (activate)="onActivate($event)"></router-outlet>

        <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
            <p style="color: white">Espere por favor ... </p>
        </ngx-spinner>
    </div>
    <app-footer tabindex="-1" *ngIf="global.current"></app-footer>
</div>